// Sarrdeh: "AI Train" page (edit the n8n AI system prompts). Administrators only.
import { frontendURL } from '../../../helper/URLHelper';
import AiTrainPage from './AiTrainPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ai-train'),
    name: 'ai_train_index',
    component: AiTrainPage,
    meta: {
      permissions: ['administrator'],
    },
  },
];
